export default __webpack_public_path__ + "static/media/ic_bybit.90c5dc27.svg";